import React from 'react';
import moment from 'moment';

const EventRow = (props) => {
  let eventPropertyKey = Object.keys(props.event["properties"])[0]
  return (
    <tr key={props.event["id"]}>
      <td className="kfi-text-left visits-far-left-column"> - {props.event["name"]}: {props.event["properties"][eventPropertyKey]}</td>
    </tr>
  );
}

const createMappingChanges = (row_data) => {

  return (
    <div>
      {row_data.map(r => {
        return (
          <>
            <div>{`Account Number: ${r.account_number}`}</div>
            <div>{`Extracted Account: ${r.extracted_account}`}</div>
            <div>{`Best Match: ${r.xlsx_matched}, Nbayes Match: ${r.n_bayes_matched}`}</div>
            <div>{`Final: ${r.final_account}`}</div>
          </>
        )
      })}
    </div>
  )
}

const ActionRow = (props) => {
  let rowStyle = {
    'borderBottom': '1px solid #000000'
  }

  if (props.id == 0) {
    rowStyle['borderTop'] = '1px solid #000000'
  }

  let actionWord = props.action.action === 'mapped_row' ? 'Mapped Row' : 'Generated Reports'
  let date = moment(props.action.date).format("MMMM D, YYYY [at] h:mm A")

  return (
    <tr style={rowStyle} key={`action-row-${props.fdu_id}-${props.id}`}>
      <td className="kfi-text-left visits-far-left-column">{date}</td>
      <td>{`${actionWord} - ${props.action.name}`}</td>
      <td className='kfi-text-left'>
        {props.action.action === 'mapped_row'
          ? createMappingChanges(props.action.row_data)
          : null
        }
      </td>
    </tr>
  );
}

export { EventRow, ActionRow };